export const PERMISSION_DENIED_MESSAGE = 'Permission Denied';

export const USER_POSITION_POLLING_INTERVAL_MS = 15 * 60 * 1000; // 15 minutes
